import { useEffect, useState } from "react";
import { useMediaQuery } from "@mui/material";

const STORAGE_KEY = "app-color-mode";

const getStoredColorMode = () => {
  const storedMode = window.localStorage.getItem(STORAGE_KEY);
  if (storedMode === "light" || storedMode === "dark") {
    return storedMode;
  }
  return undefined;
};

export const useAppColorMode = () => {
  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");

  const [colorMode, setColorMode] = useState(() => {
    const storedMode = getStoredColorMode();
    return storedMode || (prefersDarkMode ? "dark" : "light");
  });

  useEffect(() => {
    const storedMode = getStoredColorMode();
    if (!storedMode) {
      setColorMode(prefersDarkMode ? "dark" : "light");
    }
  }, [prefersDarkMode]);

  const toggleColorMode = () => {
    setColorMode((previousMode) => {
      const nextMode = previousMode === "dark" ? "light" : "dark";
      window.localStorage.setItem(STORAGE_KEY, nextMode);
      return nextMode;
    });
  };

  return {
    colorMode,
    toggleColorMode,
  };
};
